import { render, staticRenderFns } from "./UploadTenderDoc.vue?vue&type=template&id=b4f3f316&scoped=true&"
import script from "./UploadTenderDoc.vue?vue&type=script&lang=js&"
export * from "./UploadTenderDoc.vue?vue&type=script&lang=js&"
import style0 from "./UploadTenderDoc.vue?vue&type=style&index=0&id=b4f3f316&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4f3f316",
  null
  
)

export default component.exports